import React, { useState } from 'react'
import Modal from 'react-modal'
import { goto } from '../../../utilities/customRoutes'
import classnames from 'classnames';
import styled, { keyframes } from 'styled-components'
import "./index.scss";
import { config } from '../../../../helpers';
import Slider from '../../../utilities/react-slider';
import { channelInfo } from '../../../utilities/sharedData';


const AnimatePath = (c, sdo) => keyframes`
    0% {
        stroke-dashoffset: ${sdo};
        fill: rgba(202, 203, 211, 0.1);
    }

    80% {
        fill: rgba(202, 203, 211, 0.1);
    }

    100% {
        stroke-dashoffset: ${sdo * 2};
        fill: ${c};
    }
`;
const AudienceButton = styled.div`
    width: 200px;
    height: 214px;
    font-size: 18px;
    white-space: normal;
    background: var(--bb-bg-color-quaternary) !important;
    box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.16);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    &:hover{
        border: 1px solid ${props => props.colour};
        .pencil{
            animation: ${props => AnimatePath(props.colour, 1260)} 1s ease-out forwards;
        }
        .feather{
            animation: ${props => AnimatePath(props.colour, 2500)} 1s ease-out forwards;
        }
    }
`;


const SelectionBox = (props) => {

    let colour = props?.color || "transparent";
    if(config.commbank){
        colour = "#FFCC00";
    }
    if(config.mediumrare){
        colour = "#EC5B35";
    }
    const [openedInfo, setOpenedInfo] = useState(false)
    const [slider, setSlider] = useState(0);
    const [slideIndex, setSlideIndex] = useState(0);

    const BuildMyselfIcon = () => {
        return (
            <>
                <div className="bb-awesome-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-7 -7 540 540">
                        {/* <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --> */}
                        <mask id="mask-pencil">
                            <path fill="#ffffff"
                                d="M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z" />
                        </mask>
                        <path stroke={colour} className="bb-awesome-icon-path pencil" mask="url(#mask-pencil)"
                            d="M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z" />
                    </svg>
                </div>
                <div className="bb-awesome-icon-label">
                    {props.isDOOH ? "Upload Assets" : "Build Myself"}
                </div>
            </>
        )
    }

    const BriefBigIcon = () => {
        return (
            <>
                <div className="bb-awesome-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-7 -7 540 540">
                        {/* <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --> */}
                        <mask id="mask-feather">
                            <path fill="#ffffff"
                                d="M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z" />
                        </mask>
                        <path stroke={colour} className="bb-awesome-icon-path feather" mask="url(#mask-feather)"
                            d="M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z" />
                    </svg>
                </div>
                <div className="bb-awesome-icon-label">
                    Send Brief
                </div>
            </>
        )
    }
    const UploadCTagIcon = () => {
        return (
            <>
                <div className="bb-awesome-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-7 -7 540 540">
                        {/* <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --> */}
                        <mask id="mask-feather">
                            <path fill="#ffffff"
                                d="M235.326 476.514L183.861 461.581C178.461 460.062 175.424 454.41 176.943 449.01L292.106 52.3094C293.624 46.9098 299.277 43.8726 304.677 45.3912L356.141 60.3244C361.541 61.8431 364.578 67.4958 363.059 72.8953L247.897 469.596C246.294 474.996 240.725 478.117 235.326 476.514V476.514ZM139.146 381.853L175.846 342.706C179.727 338.572 179.474 331.991 175.171 328.194L98.7332 260.953L175.171 193.711C179.474 189.914 179.811 183.334 175.846 179.2L139.146 140.053C135.349 136.003 128.937 135.75 124.803 139.631L3.22819 253.528C-1.0746 257.494 -1.0746 264.328 3.22819 268.293L124.803 382.275C128.937 386.156 135.349 385.987 139.146 381.853V381.853ZM415.199 382.359L536.774 268.377C541.077 264.412 541.077 257.578 536.774 253.613L415.199 139.546C411.149 135.75 404.737 135.919 400.856 139.968L364.156 179.115C360.275 183.249 360.528 189.83 364.831 193.627L441.269 260.953L364.831 328.194C360.528 331.991 360.191 338.572 364.156 342.706L400.856 381.853C404.653 385.987 411.065 386.156 415.199 382.359V382.359Z" />
                        </mask>
                        <path stroke={colour} className="bb-awesome-icon-path feather" mask="url(#mask-feather)"
                            d="M235.326 476.514L183.861 461.581C178.461 460.062 175.424 454.41 176.943 449.01L292.106 52.3094C293.624 46.9098 299.277 43.8726 304.677 45.3912L356.141 60.3244C361.541 61.8431 364.578 67.4958 363.059 72.8953L247.897 469.596C246.294 474.996 240.725 478.117 235.326 476.514V476.514ZM139.146 381.853L175.846 342.706C179.727 338.572 179.474 331.991 175.171 328.194L98.7332 260.953L175.171 193.711C179.474 189.914 179.811 183.334 175.846 179.2L139.146 140.053C135.349 136.003 128.937 135.75 124.803 139.631L3.22819 253.528C-1.0746 257.494 -1.0746 264.328 3.22819 268.293L124.803 382.275C128.937 386.156 135.349 385.987 139.146 381.853V381.853ZM415.199 382.359L536.774 268.377C541.077 264.412 541.077 257.578 536.774 253.613L415.199 139.546C411.149 135.75 404.737 135.919 400.856 139.968L364.156 179.115C360.275 183.249 360.528 189.83 364.831 193.627L441.269 260.953L364.831 328.194C360.528 331.991 360.191 338.572 364.156 342.706L400.856 381.853C404.653 385.987 411.065 386.156 415.199 382.359V382.359Z" />
                    </svg>
                </div>
                <div className="bb-awesome-icon-label">
                    Upload creative tag
                </div>
            </>
        )
    }
    const OffsetTracker = () => {
        return (
            <>
                <div className="bb-awesome-icon">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-7 -7 540 540">
                        {/* <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --> */}
                        <mask id="mask-plus">
                            <path fill="#ffffff"
                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" />
                        </mask>
                        <path stroke={colour} className="bb-awesome-icon-path feather" mask="url(#mask-plus)"
                            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" />
                    </svg>
                </div>
                <div className="bb-awesome-icon-label px-2">
                    Create offset tracker for use outside Buddy
                </div>
            </>
        )
    }

    const OffsetPending = () => {
        return (
            <>
                <div className="bb-awesome-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-120 -7 540 540">
                        {/* <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --> */}
                        <mask id="mask-bolt">
                            <path fill="#ffffff"
                                d="M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z" />
                        </mask>
                        <path stroke={colour} className="bb-awesome-icon-path feather" mask="url(#mask-bolt)"
                            d="M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z" />
                    </svg>
                </div>
                <div className="bb-awesome-icon-label px-2">
                    Offset pending emissions
                </div>
            </>
        )
    }

    const OffsetDashboard = () => {
        return (
            <>
                <div className="bb-awesome-icon">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7 575 640">
                        {/* <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --> */}
                        <mask id="mask-eye">
                            <path fill="#ffffff"
                                d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z" />
                        </mask>
                        <path stroke={colour} className="bb-awesome-icon-path feather" mask="url(#mask-eye)"
                            d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z" />
                    </svg>
                </div>
                <div className="bb-awesome-icon-label px-2">
                    View emission dashboard
                </div>
            </>
        )
    }

    const OffsetWithBuddy = () => {
        return (
            <>
                <div className="container-p simple-no-delay">
                    <div className="container-content__wrapper">
                        <div className="icon">
                            <svg xmlns="http://www.w3.org2000/svg" viewBox="0 0 540 540">
                                {/* <!-- Font Awesome Pro /5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --> */}
                                <mask id="mask-withbuddy">
                                    <path fill="#ffffff"
                                        d="M67.4998 22.7378C67.4998 10.1936 77.6695 -5.12769e-05 90.2376 -5.01781e-05L130.988 -4.66156e-05C143.532 -4.5519e-05 153.726 10.1697 153.726 22.7378L153.726 168.375C191.526 141.488 238.825 127.025 289.673 131.246C386.045 139.233 465.219 216.034 475.749 312.166C489.252 435.593 392.953 540 272.284 540C162.408 540 72.7765 453.462 67.7876 344.833L67.5478 344.833L67.5478 22.7378M153.75 335.263C153.75 400.743 206.805 453.798 272.284 453.798C337.763 453.798 390.818 400.743 390.818 335.263C390.818 269.784 337.739 216.729 272.284 216.729C206.805 216.729 153.75 269.808 153.75 335.263Z" />
                                </mask>
                                <path className="icon-path withbuddy" mask="url(#mask-withbuddy)"
                                    d="M67.4998 22.7378C67.4998 10.1936 77.6695 -5.12769e-05 90.2376 -5.01781e-05L130.988 -4.66156e-05C143.532 -4.5519e-05 153.726 10.1697 153.726 22.7378L153.726 168.375C191.526 141.488 238.825 127.025 289.673 131.246C386.045 139.233 465.219 216.034 475.749 312.166C489.252 435.593 392.953 540 272.284 540C162.408 540 72.7765 453.462 67.7876 344.833L67.5478 344.833L67.5478 22.7378M153.75 335.263C153.75 400.743 206.805 453.798 272.284 453.798C337.763 453.798 390.818 400.743 390.818 335.263C390.818 269.784 337.739 216.729 272.284 216.729C206.805 216.729 153.75 269.808 153.75 335.263Z" />
                            </svg>
                        </div>
                        <div className="bb-awesome-icon-label">
                            Offset with Buddy
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const OffsetWithOwnProvider = () => {
        return (
            <>
                <div className="container-p simple-no-delay">
                    <div className="container-content__wrapper">
                        <div className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 540 540">
                                {/* <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --> */}
                                <mask id="mask-ownprovider">
                                    <path fill="#ffffff"
                                        d="M162 279C214.228 279 256.5 236.728 256.5 184.5C256.5 132.272 214.228 90 162 90C109.772 90 67.5 132.272 67.5 184.5C67.5 236.728 109.772 279 162 279ZM226.8 306H219.797C202.247 314.438 182.756 319.5 162 319.5C141.244 319.5 121.837 314.438 104.203 306H97.2C43.5375 306 0 349.538 0 403.2V427.5C0 449.859 18.1406 468 40.5 468H283.5C305.859 468 324 449.859 324 427.5V403.2C324 349.538 280.462 306 226.8 306ZM405 279C449.719 279 486 242.719 486 198C486 153.281 449.719 117 405 117C360.281 117 324 153.281 324 198C324 242.719 360.281 279 405 279ZM445.5 306H442.294C430.566 310.05 418.163 312.75 405 312.75C391.837 312.75 379.434 310.05 367.706 306H364.5C347.288 306 331.425 310.978 317.503 318.994C338.091 341.184 351 370.631 351 403.2V435.6C351 437.456 350.578 439.228 350.494 441H499.5C521.859 441 540 422.859 540 400.5C540 348.272 497.728 306 445.5 306V306Z" />
                                </mask>
                                <path className="icon-path ownprovider" mask="url(#mask-ownprovider)"
                                    d="M162 279C214.228 279 256.5 236.728 256.5 184.5C256.5 132.272 214.228 90 162 90C109.772 90 67.5 132.272 67.5 184.5C67.5 236.728 109.772 279 162 279ZM226.8 306H219.797C202.247 314.438 182.756 319.5 162 319.5C141.244 319.5 121.837 314.438 104.203 306H97.2C43.5375 306 0 349.538 0 403.2V427.5C0 449.859 18.1406 468 40.5 468H283.5C305.859 468 324 449.859 324 427.5V403.2C324 349.538 280.462 306 226.8 306ZM405 279C449.719 279 486 242.719 486 198C486 153.281 449.719 117 405 117C360.281 117 324 153.281 324 198C324 242.719 360.281 279 405 279ZM445.5 306H442.294C430.566 310.05 418.163 312.75 405 312.75C391.837 312.75 379.434 310.05 367.706 306H364.5C347.288 306 331.425 310.978 317.503 318.994C338.091 341.184 351 370.631 351 403.2V435.6C351 437.456 350.578 439.228 350.494 441H499.5C521.859 441 540 422.859 540 400.5C540 348.272 497.728 306 445.5 306V306Z" />
                            </svg>
                        </div>
                        <div className="bb-awesome-icon-label">
                            I have my own provider
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const getCommbankSvg = (desc) => {
    switch (desc) {
        case 'In-Branch':
            return (
                <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
<path className="custom-svg-path" d="M89.125 23V25.875C89.125 26.2562 88.9736 26.6219 88.704 26.8915C88.4344 27.161 88.0687 27.3125 87.6875 27.3125H83.375V29.4687C83.375 30.6595 82.4095 31.625 81.2188 31.625H10.7812C9.59046 31.625 8.625 30.6595 8.625 29.4687V27.3125H4.3125C3.93125 27.3125 3.56562 27.161 3.29603 26.8915C3.02645 26.6219 2.875 26.2562 2.875 25.875V23C2.875 22.7156 2.95936 22.4376 3.1174 22.2012C3.27544 21.9647 3.50006 21.7805 3.76284 21.6717L45.4503 5.85924C45.8023 5.71351 46.1977 5.71351 46.5497 5.85924L88.2372 21.6717C88.4999 21.7805 88.7246 21.9647 88.8826 22.2012C89.0406 22.4376 89.125 22.7156 89.125 23V23ZM84.8125 77.625H7.1875C4.80574 77.625 2.875 79.5557 2.875 81.9375V84.8125C2.875 85.1938 3.02645 85.5594 3.29603 85.829C3.56562 86.0986 3.93125 86.25 4.3125 86.25H87.6875C88.0687 86.25 88.4344 86.0986 88.704 85.829C88.9736 85.5594 89.125 85.1938 89.125 84.8125V81.9375C89.125 79.5557 87.1943 77.625 84.8125 77.625ZM17.25 34.5V69H10.7812C9.59046 69 8.625 69.9655 8.625 71.1563V74.75H83.375V71.1563C83.375 69.9655 82.4095 69 81.2188 69H74.75V34.5H63.25V69H51.75V34.5H40.25V69H28.75V34.5H17.25Z" fill="#CACBD3" fillOpacity="0.2"/>
</svg>

            );        
        case 'Digital':
            return (
                <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="custom-svg-path" fillRule="evenodd" clipRule="evenodd" d="M86.1321 32.5852C89.1069 32.5867 91.5227 35.0007 91.5227 37.9758V84.6946C91.5227 87.6697 89.1069 90.0837 86.1321 90.0852H60.9758C57.9998 90.0852 55.5852 87.6707 55.5852 84.6946V37.9758C55.5852 34.9998 57.9998 32.5852 60.9758 32.5852H86.1321ZM73.554 79.304C71.5662 79.304 69.9602 80.9099 69.9602 82.8977C69.9602 84.8855 71.5662 86.4915 73.554 86.4915C75.5405 86.4899 77.1477 84.8846 77.1477 82.8977C77.1477 80.9108 75.5405 79.3055 73.554 79.304ZM62.3235 37.9758C61.5823 37.9758 60.9758 38.5823 60.9758 39.3235V74.3625C60.9758 75.1038 61.5823 75.7102 62.3235 75.7102H84.7844C85.5244 75.7087 86.1321 75.1028 86.1321 74.3625V39.3235C86.1321 38.5832 85.5244 37.9774 84.7844 37.9758H62.3235Z" fill="#CACBD3" fill-opacity="0.2" />
                        <path className="custom-svg-path" d="M36.6899 65.5522C36.6543 67.6408 38.7146 70.1511 41.4011 70.1511H50.1384C50.7106 70.1511 51.2489 70.0453 51.75 69.8816V79.3545H9.19775C4.13877 79.3533 0 75.2104 0 70.1511V67.8545C0 66.5895 1.03725 65.5522 2.30225 65.5522H36.6899Z" fill="#CACBD3" fillOpacity="0.2" />
                        <path className="custom-svg-path" d="M75.9011 5.75C79.6954 5.75061 82.8019 8.85678 82.8022 12.6511V26.8352H73.5989V14.9534H18.4011V51.75H51.75V60.9534H9.19775V12.6511C9.1981 8.85678 12.3046 5.75061 16.0989 5.75H75.9011Z" fill="#CACBD3" fillOpacity="0.2" />
                    </svg>
            );
        case 'Content':
            return (
                <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="custom-svg-path" d="M13.6226 81.0731C11.8593 81.0731 10.3304 80.4256 9.03605 79.1306C7.74102 77.8362 7.09351 76.3073 7.09351 74.544V17.4561C7.09351 15.6863 7.74102 14.152 9.03605 12.8532C10.3304 11.5537 11.8593 10.9039 13.6226 10.9039H78.3772C80.1469 10.9039 81.6812 11.5537 82.9801 12.8532C84.2796 14.152 84.9293 15.6863 84.9293 17.4561V74.544C84.9293 76.3073 84.2796 77.8362 82.9801 79.1306C81.6812 80.4256 80.1469 81.0731 78.3772 81.0731H13.6226ZM13.6226 74.544H78.3772V17.4561H13.6226V74.544ZM23.9774 64.4767H68.0454V58.7267H23.9774V64.4767ZM23.9774 48.6833H38.8316V27.5003H23.9774V48.6833ZM48.6833 48.6833H68.0454V42.9333H48.6833V48.6833ZM48.6833 33.2503H68.0454V27.5003H48.6833V33.2503Z" fill="#CACBD3" fillOpacity="0.2"/>
                </svg>

            );
        default:
            return null;
    }
};

    const CustomBox = () => {

        return (
            <>

                {config.commbank ? <div className="icon">

                    {getCommbankSvg(props.desc)}
                
                </div> : config.mediumrare ? <div className="icon">
                    {props.svgIcon ? props.svgIcon :  <div className={`custom-svg-path svg-class ${props.icon}`}></div>}
                </div> : <div className={`custom-svg-path svg-class ${props.icon}`}>
                </div>}
                {props.subText && <div className='bb-form-input_color bb-font_12px my-1'>
                    {props.subText}
                </div>}
                <div className={classnames("bb-awesome-icon-label pt-0", props.subText ? "" : "mt-4")}>
                    {props.desc}
                </div>
                {!props.isReady && <small className="text-white mt-3">Coming soon</small>}
                {props.hasAIAlpha &&
                    <div className="bb-awesome-ai-alpha floating_5" >
                        <img src="/images/ai_alpha_logo.png" alt="" />
                    </div>

                }
            </>
        )
    }

    const toggleInfo = (info = null) => {
        setOpenedInfo(info)
    }
    const renderInfoModal = () => {
        const deals = channelInfo[openedInfo]
        return (
            openedInfo && <Modal
                isOpen={openedInfo ? true : false}
                onRequestClose={() => toggleInfo()}
                overlayClassName="bb-modal-overlay"
                className="bb-modal-container mw-900 bg-modal-slider"
                ariaHideApp={false}
                bodyOpenClassName="overflow-hidden"
            >
                <Slider onRef={ref => setSlider(ref)} touchDisabled={true} slideNo={deals.length} slideIndex={slideIndex}>
                    {deals?.map((deal, idx) => <div key={idx}>
                        <div className="d-flex flex-row justify-content-between bb-modal-header audience-modal-header text-uppercase">
                            <div className="fas fa-times-circle fa-2x cursor-pointer bb-modal-close" onClick={() => toggleInfo()}></div>
                        </div>

                        <div className="d-flex flex-wrap justify-content-between slider-card-scroll-curated">
                            <div className="col-sm-12 col-md-7 d-flex flex-wrap pl-sm-5 pb-4">
                                <div>
                                    {deal.subTitle ? <>
                                        <h3>{deal.name}</h3>
                                        <div className="my-3 py-1 bb-font_13px font-weight-bold">{deal.subTitle}</div>
                                    </> : <h3 className="mb-5">{deal.name}</h3>}
                                    <div className="w-100 my-2 min-height_194px html">{(deal.description)}</div>
                                </div>
                                <div className='align-content-end w-100'>
                                    {deal?.details?.length > 0 && <div>
                                        <p className="font-weight-bold bb-text_small w-100 text-uppercase m-0">DETAILS</p>
                                        {deal?.details.map((detail, idx) =>
                                            <div className="w-100 d-flex flex-row border-bottom py-2" key={idx}>
                                                <span className='col-1 p-0 text-center align-content-center'>
                                                    <i className={`${detail.icon} fa-2x align-self-center`} aria-hidden="true"></i>
                                                </span>
                                                <div className="d-flex flex-column align-self-center ml-3">
                                                    <p className="font-weight-bold m-0 bb-text_small ">{detail.label}</p>
                                                    <span className="align-self-start">
                                                        {detail.value}
                                                    </span>
                                                </div>
                                            </div>)
                                        }
                                    </div>}
                                </div>
                            </div>
                            <div className={"col-sm-12 col-md-5 bm-slider-deal-image p-0 pr-5 "}>
                                <div className="position-relative">
                                    <img className=" bm-logo-c-deal-slider deal" src={deal.image || "/images/thumbnail.png"}
                                        onError={(e) => e.target.src = "/images/thumbnail.png"}
                                        alt="" />
                                </div>
                            </div>
                        </div>
                    </div>)}
                </Slider>

            </Modal>
        )
    }

    return (
        <>
        {openedInfo && renderInfoModal()}
        <AudienceButton className={classnames("bb-audience-button mx-3 mb-3", props.className, props.isReady ? "" : "bb-button-not-ready", props.isCustomized ? "selection-box-customized" : "", props.subText === "Retailer" ? "retailer" : "")}
            onClick={(e) => {
                e.stopPropagation();
                if (props.onClick) { props.onClick() }
                else {
                    props.elink ? window.open(props.elink, "_blank") : goto(props.isReady ? props.loc : "")
                }
            }}
            colour={colour}
        >
            {(config.commbank || config.mediumrare) && !props.noInfo ? <i className="fas fa-1dot5x text-white fa-info-circle cursor-pointer selection-box-info cursor-pointer" onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleInfo(props.desc)
            }}> </i> : null}
            {props.isAwesomeIcon
                ? <div className='bb-awesome-icon-container'>
                    {props.icon === "buildmyself" ? <BuildMyselfIcon /> : null}
                    {props.icon === "briefbig" ? <BriefBigIcon /> : null}
                    {props.icon === "uploadcreativetag" ? <UploadCTagIcon /> : null}
                    {props.icon === "dashboard" ? <OffsetDashboard /> : null}
                    {props.icon === "pending" ? <OffsetPending /> : null}
                    {props.icon === "tracker" ? <OffsetTracker /> : null}
                    {props.icon === "offsetwithbuddy" ? <OffsetWithBuddy /> : null}
                    {props.icon === "offsetwithownprovider" ? <OffsetWithOwnProvider /> : null}

                </div>


                : props.isCustomized ? <CustomBox /> : <div className="d-flex flex-column text-center">
                    <strong>{props.name}</strong>

                    {props.caption ? <small className="text-white mt-3 font-italic">{props.caption}</small> : null}
                    {props.desc ? <small className="text-white mt-3 px-2">{props.desc}</small> : null}


                    {!props.isReady && <small className="text-white mt-3">Coming soon</small>}
                </div>
            }
        </AudienceButton>
        </>
    )
}

export default SelectionBox